import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private baseUrl: string;

 constructor(
  private http: HttpClient,
  @Inject(PLATFORM_ID) private platformId: any,
  @Inject(DOCUMENT  ) private document: Document
) {
  this.baseUrl = isPlatformBrowser(this.platformId)
    ? environment.apiUrl
    : environment.apiUrl.startsWith('http') ? environment.apiUrl : 'https://ncareivfkannur.com';
}

  commonApi<T>(
    method: HttpMethod,
    url: string,
    data?: any,
    options: {
      headers?: HttpHeaders | { [header: string]: string | string[] };
      params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
      observe?: 'body';
      responseType?: 'json';
    } = {}
  ): Observable<T> {

    const fullUrl = this.formatUrl(url);

    const finalOptions = {
      ...options,
      observe: 'body' as const,
      responseType: 'json' as const
    };

    switch (method.toUpperCase()) {
      case 'GET':
        return this.http.get<T>(fullUrl, finalOptions);
      case 'POST':
        return this.http.post<T>(fullUrl, data, finalOptions);
      case 'PUT':
        return this.http.put<T>(fullUrl, data, finalOptions);
      case 'DELETE':
        return this.http.delete<T>(fullUrl, finalOptions);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }

  downloadBlob(url: string, params: { [key: string]: string | number }): Observable<Blob> {
    const fullUrl = this.formatUrl(url);
    return this.http.get(fullUrl, {
      params,
      responseType: 'blob'
    });
  }

  /**
   * Ensure correct absolute URL both in browser and server (SSR-safe)
   */
  private formatUrl(url: string): string {
    if (url.startsWith('http')) {
      return url;  // Already full URL
    }
    return `${this.baseUrl}${url.startsWith('/') ? url : '/' + url}`;
  }

  public setAppFavicon(icon: string): void {
  if (!isPlatformBrowser(this.platformId)) return; // Only run in browser

  const faviconElement = this.document.getElementById('appFavicon') as HTMLLinkElement;

  const fallbackIcon = 'assets/image/logo_icon.png';
  if (!faviconElement) return;

  if (icon) {
    const imageUrl = `${environment.apiUrl}${icon}`;
    this.imageExists(imageUrl, (exists) => {
      faviconElement.setAttribute('href', exists ? imageUrl : fallbackIcon);
    });
  } else {
    faviconElement.setAttribute('href', fallbackIcon);
  }
}

private imageExists(url: string, callback: (exists: boolean) => void): void {
  const img = new Image();
  img.onload = () => callback(true);
  img.onerror = () => callback(false);
  img.src = url;
}

}
